import { useIsPresent } from 'framer-motion'
import type { Task } from '@/src/renderer/lib/db/models'
import { ClarifyHeader } from './ClarifyHeader'
import { ClarifyBody } from './ClarifyBody'
import { useClarifyController } from './useClarifyController'

export interface ClarifySessionProps {
  tasks: Task[]
  lifeSpace: 'personal' | 'work' | 'home'
  onExit: () => void
  /** Aus, solange der Tab nicht vorn ist: Tasten und Menü „Aufgaben“ gehören dann dem anderen Tab. */
  isActive?: boolean
}

/**
 * Renders the two DOM blocks that make up Clarify-Mode inside the Quick-Notes
 * page: the Header (in the toolbar slot where the "Einträge klären" button
 * would otherwise sit) and the Body (in the mode slot where the task list
 * would otherwise sit). Owns the controller so state is captured fresh on
 * each entry into the mode.
 */
export function ClarifySession({ tasks, lifeSpace, onExit, isActive = true }: ClarifySessionProps) {
  /*
    Beim Verlassen blendet die Session noch aus (AnimatePresence). Schon ab dann gehören Tasten und Menü
    „Aufgaben“ wieder der Liste — meldete sie sich erst am Ende ab, käme ihr `null` nach dem Zustand der
    Liste an, und das Menü bliebe grau (Diff-Audit 06.10.2026). Außerhalb von AnimatePresence: immer da.
  */
  const present = useIsPresent()
  const { headerProps, bodyProps } = useClarifyController({ tasks, onExit, enabled: isActive && present })
  return (
    <>
      <div className="quick-notes-page__clarify-bar quick-notes-page__clarify-bar--clarify-mode">
        <ClarifyHeader {...headerProps} />
      </div>
      <div className="quick-notes-page__mode-slot">
        <ClarifyBody {...bodyProps} lifeSpace={lifeSpace} />
      </div>
    </>
  )
}
